import * as React from 'react';

import ClearAllView from 'filter-clear-all.view';
import { removeAllEventFilters } from '../../redux-state/actions/package-listing.actions';
import { IPackageListingAppState } from '../../redux-state';
import { connect } from 'react-redux';
import { IPackageListingAppText } from '../../custom/classes/package-listing-text';


interface IFilterExternalProps {
}

interface StateToProps {
    text: IPackageListingAppText;
}

interface DispatchToProps {
    removeAllFilters: () => void;
}

export type ClearAllProps = IFilterExternalProps & StateToProps & DispatchToProps;

export class ClearAllBase extends React.Component<ClearAllProps, null> {
    render() {
        return <ClearAllView {...this.props} />;
    }
}

function mapStateToProps(state: IPackageListingAppState, ownProps: IFilterExternalProps): StateToProps {
    return {
        text: state.packageListingText
    }
}

function mapDispatchToProps(dispatch): DispatchToProps {
    return {
        removeAllFilters: () => dispatch(removeAllEventFilters())
    }
}

export default connect<StateToProps, DispatchToProps>(mapStateToProps, mapDispatchToProps)(ClearAllBase);